<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';

  import ObjectListType from './ObjectListType.svelte';

  interface Props {
    value?: Array<ObjectType<string>>;
  }

  let { value = [] }: Props = $props();
</script>

<div data-cy="arrayObjectList" class="comp-array-object-list-type">
  {#each value as obj}
    <div class="items"><ObjectListType value={obj} /></div>
  {:else}
    {EmptyLabelDefault}
  {/each}
</div>

<style>
  .comp-array-object-list-type {
    width: 100%;
    padding: 12px 16px;
  }
  .comp-array-object-list-type .items {
    padding-bottom: 8px;
  }
  .comp-array-object-list-type .items:not(:last-child) {
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 8px;
  }
</style>
